import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import bgImage from "../assets/images/background1.png";
import Arrow from "../assets/images/arrow.svg";
import Star from "../assets/images/star.svg";
import Graph1 from "../assets/images/graph1.svg";
import Graph2 from "../assets/images/graph-2.svg";
import Greentick from "../assets/images/grrentick.svg";
import Greater from "../assets/images/greaterthan.svg";
import "../assets/css/swiper.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const images = [
    // {
    //   id: 1,
    //   url: CpgramImage,
    //   title: "UP CM Helpline Portal",
    //   description:
    //     "A dedicated platform to address and resolve citizen grievances efficiently. Empowering transparency and accessibility for all.",
    // },
    {
      id: 2,
      url: bgImage,
      title: "CAG GRMS",
      description: "Grievance Redressal Powered by Innovation",
      subtitle: "Empower Citizens",
      description2:
        "Join hands in building a transparent and effective grievance redressal platform. Track, manage, and resolve grievances with cutting-edge technology.",
    },
  ];

  const card = [
    {
      title: "Grievance status is updated",
      discription: "2m ago",
    },
    {
      title: "New update on grievance",
      discription: "5m ago",
    },
    {
      title: "Response received",
      discription: "10m ago",
    },
  ];

  return (
    <div className="flex-grow w-full relative">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        loop
        className="absolute inset-0 w-full h-full"
      >
        {images.map((image) => (
          <SwiperSlide key={image.id}>
            <div
              className="relative w-full h-full flex items-center justify-center text-white"
              style={{
                backgroundImage: `url(${image.url})`,
                backgroundSize: "130% 130%",
                backgroundPosition: "right bottom",
              }}
            >
              {/* Black Overlay */}
              {/* <div className="absolute inset-0 bg-black opacity-70"></div> */}

              {/* Content */}
              <div className="flex flex-col md:flex-row items-center">
                <div className="w-full md:w-[70%] ml-4 md:ml-12 relative text-start px-4 md:px-6">
                  <h1 className="inline-block text-[36px] sm:text-[40px] md:text-[55px] lg:text-[70px] font-bold bg-gradient-to-r from-[#009689] via-[#0092B8] to-[#155DFC] bg-clip-text text-transparent mb-2 md:mb-4">
                    {image.title}
                  </h1>
                  <p className="text-base sm:text-lg md:text-2xl font-bold text-black mb-3 md:mb-6">
                    {image.description}
                  </p>
                  <h1 className="text-lg sm:text-xl md:text-2xl text-[#F54900] font-bold mb-2 md:mb-4">
                    {image.subtitle}
                  </h1>
                  <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-4 md:mb-6">
                    {image.description2}
                  </p>
                  <div className="flex flex-wrap gap-3">
                  <button
                    className="bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white font-semibold py-2 px-4 sm:px-6 rounded-lg shadow-md transition duration-300 inline-flex items-center text-sm sm:text-base"
                    onClick={() => navigate("/login")}
                  >
                    <span>Sign In</span>
                    <img src={Arrow} alt="arrow" className="ml-1 w-4 h-4" />
                  </button>
                  <button
                    className="bg-[#F0FDFA] hover:bg-[#bafeee] text-[#00786F] font-semibold py-2 px-4 sm:px-6 rounded-lg shadow-md transition duration-300 inline-flex items-center text-sm sm:text-base"
                    onClick={() => navigate("/register")}
                  >
                    <span>Sign Up</span>
                    <img src={Star} alt="star" className="ml-1 w-4 h-4" />
                  </button>
                  </div>
                </div>
                <div className="hidden md:flex w-[90%] flex-col items-center justify-center ">
                  <div className="-mr-[50%]  shadow-xl shadow-gray-400">
                    <img src={Graph1} alt="graph" className="w-25 h-20" />
                  </div>
                  <div className="w-[40%] h-auto bg-white text-black  p-2 rounded-lg shadow-xl shadow-gray-400">
                    <h1 className="font-bold">Live Updates</h1>
                    {card.map((card) => (
                      <div className="w-[90%] bg-[#ECFDF5] m-2 p-2 rounded-md flex items-center justify-between">
                        <img
                          src={Greentick}
                          alt="tick"
                          className="ml-1 w-4 h-4"
                        />

                        <div className="w-[75%] text-start">
                          <h3>{card.title}</h3>
                          <p className="text-sm text-gray-500">
                            {card.discription}
                          </p>
                        </div>
                        <img
                          src={Greater}
                          alt="tick"
                          className="ml-1 w-4 h-4"
                        />
                      </div>
                    ))}
                  </div>
                  <div className="-ml-[50%]  shadow-xl shadow-gray-400">
                    <img src={Graph2} alt="graph" className="w-25 h-20" />
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Home;
